import moment from 'moment';

export class ApiCourseVendorUpdate {
    id: number;
    name: string;
    description: string;
    status: string;
    address: string;
    city: string;
    state: string;
    zip: string;
    email: string;
    phone: string;
    facebook: string;
    twitter: string;
    youtube: string;
    join_url: string;
    docebo: {[name: string]: boolean};
    zoom: {[name: string]: boolean};
    sort_order: number;
    website: string;
    logo: File;
    video_url: string;

    constructor(data) {
        if (data.id) this.id = data.id;
        this.name = data.name;
        this.description = data.description;
        this.status = data.status;
        this.join_url = data.joinUrl;
        this.address = data.address;
        this.city = data.city;
        this.state = data.state;
        this.zip = data.zip;
        this.email = data.email;
        this.phone = data.phone;
        this.facebook = data.facebook;
        this.twitter = data.twitter;
        this.youtube = data.youtube;
        if ("docebo" in data) {
            this.docebo = {
                status: data.docebo, 
                show_open: data.doceboShowOpen
            };
        }
        if ("zoom" in data) {
            this.zoom = {
                status: data.zoom, 
                show_open: data.zoomShowOpen
            };
        }
        this.sort_order = data.sortOrder != null ? data.sortOrder : "";
        this.website = data.website;
        this.logo = data.logo;
        this.video_url = data.videoUrl;
    }
}
